import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import isEqual from 'lodash/isEqual';
export function createDefaultColorPallet(colors, colorPallets) {
  // Check if color pallet already exists in the list
  // If it does - do not create a new one
  const isExist = colorPallets.find(pallet => isEqual(pallet.colors, colors));
  if (isExist) return null;
  return colors.length ? {
    name: 'Default',
    colors: colors,
    initialColors: colors,
    category: ['popular']
  } : null;
} // Merge color pallets with customized colors

export function getColorPalletsWithOverrides(colorPallets, overrides) {
  return colorPallets.map(pallet => _objectSpread(_objectSpread({}, pallet), {}, {
    colors: overrides[pallet.name] || pallet.colors,
    initialColors: pallet.colors
  }));
} // Find category based on provided colors

export function findActiveCategory(colors, colorPallets) {
  if (!colors || colors.length === 0) return null;
  const found = colorPallets.find(pallet => isEqual(pallet.colors, colors));
  if (!found) return null;
  return found.category[0];
} // Replace color at index

export function replaceColor(colors, color, idx) {
  return colors.map((c, i) => i === idx ? color : c);
} // Add color to pallet

export function addColor(colors, color) {
  return [...colors, color];
} // Delete color at index

export function deleteColor(colors, idx) {
  return colors.filter((_, i) => i !== idx);
}